export const getYnPageWidth = (state) => state.ui.ynPage.width;
export const getYnPageHeight = (state) => state.ui.ynPage.height;
